import React from "react";
import { useWizardContextState } from "../../context/wizardContext";
import FittingInstructions from "./fittingInstructions";
import VideoWithCaptions from "./WizardComponents/videoWithCaptions";
import styles from "./puttingOnYourBra.module.css";

export const PuttingOnYourBra = (props) => {
  const { breastSupportRecommended } = props;
  const { cup } = useWizardContextState();

  let videoSrcCup = "";
  let videoPosterCup = "";

  if (cup <= "D") {
    videoSrcCup = require(`../../assets/video/PutOnCupSM.mp4`);
    videoPosterCup = require(
      "../../assets/video/SmallMediumBreastedPutOnBraCorrectlyFinalCut.png"
    );
  } else {
    videoSrcCup = require(`../../assets/video/PutOnCupL.mp4`);
    videoPosterCup = require(
      "../../assets/video/LargeBreastedPutBraOnCorrectlyFinalCut.png"
    );
  }

  return (
    <div className={styles.outerContainer}>
      <div className={styles.videoTextRow}>
        <div className={styles.videoContainer}>
          <VideoWithCaptions
            videoSource={videoSrcCup}
            videoPoster={videoPosterCup}
            part="Cup"
          />
        </div>

        <div className={styles.textContainer}>
          <p>
            <strong>When purchasing a new sports bra:</strong><br />
            <ol>
              <li>Choose a band size to match your shirt size and an approximate cup size (i.e., small breast (A or B), medium breast (C or D), large breast (DD, E ), extra large breast ( F+)</li>
              <li>Adjust the straps so they are firm on your shoulders.</li>
              <li>Follow the steps below to determine if it is the correct size.</li>
            </ol>
            <br />
            Pull your breast tissue into the cup of the sports bra following the
            instructions in the video.
          </p>
        </div>
      </div>

      <FittingInstructions
        breastSupportRecommended={breastSupportRecommended}
      />
    </div>
  );
};

export default PuttingOnYourBra;
